// extracted by mini-css-extract-plugin
module.exports = {"category":"show-card_category__cxWrr","text":"show-card_text__SPPNQ","media":"show-card_media__BEjkf"};